const styles = (theme) => ({
	resumo: {
		marginBottom: "12px",
	},
	listaScripts: {
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
		maxHeight: "220px",
		overflowY: "auto",
		marginBottom: "12px",
	},
	linhaScript: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1,
		padding: "6px 0px",
		borderTop: `1px solid ${theme.palette.divider}`,
	},
	nomeScript: {
		color: theme.palette.text.primary,
		fontWeight: 500,
	},
	contagemScript: {
		color: theme.palette.text.secondary,
		whiteSpace: "nowrap",
	},
	aviso: {
		color: theme.palette.text.secondary,
		marginBottom: "12px",
	},
	confirmacaoContainer: {
		marginTop: "8px",
	},
	erro: {
		color: theme.palette.chip.colorText.critical,
		marginTop: "12px",
	},
	resultadoContainer: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	resumoGeralContainer: {
		display: "flex",
		flexWrap: "wrap",
		gap: 1,
		paddingBottom: "8px",
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	chip: {
		fontWeight: 600,
	},
	linhaResultado: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1,
		padding: "8px 0px",
		borderTop: `1px solid ${theme.palette.divider}`,
	},
	nomeResultado: {
		minWidth: "160px",
		fontWeight: 500,
		color: theme.palette.text.primary,
	},
	// Aviso de sucesso (ex. recoleta nao confirmou avanco) - tom de atencao, nao de falha, mesmo
	// token ja usado em modalAtualizarScripts/styles.js
	avisoResultado: {
		color: theme.palette.chip.colorText.medium,
		flexBasis: "100%",
	},
	semItens: {
		color: theme.palette.text.secondary,
	},
});

export default styles;
